// Forked from ../SearchBar/SearchInput.tsx to restyle without touching SpotlightOLD — keep in sync until phase_0
// cleanup.
import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { CSRF } from '../../../helpers/csrf';
import { isCollectionPage } from '../helpers/searchUtils';
import { useSpotlightCapabilities } from '../hooks/useSpotlightCapabilities';
import { useSearchMode, useSpotlightDropdownContext, useSearch } from '../SpotlightState';

interface SearchInputProps {
	collectionId: string | undefined;
}

// Keep #spotlightForm, #focus-new and the hidden fields in sync with the old fork — e2e and filterhelper.js
// depend on them.
export function SearchInput({ collectionId }: SearchInputProps) {
	const { searchTerm, onValueChange } = useSearch();
	const { refInput, isDropdownOpen, openSpotlightDropdown } = useSpotlightDropdownContext();
	const { isPerformingNLSSearch } = useSearchMode();
	const { translate } = useTranslate();
	const { canShowStickySearch } = useSpotlightCapabilities();
	const isOnCollectionPage = isCollectionPage(window.location.pathname);

	const openPlaceholderKey = isPerformingNLSSearch
		? 'spotlight.searchSomethingNLS'
		: 'spotlight.searchSomething';
	const closedPlaceholderKey = isPerformingNLSSearch
		? 'spotlight.redesign.searchPlaceholderNLS'
		: 'spotlight.redesign.searchPlaceholder';
	const placeholderText = translate(isDropdownOpen ? openPlaceholderKey : closedPlaceholderKey);

	return (
		<form
			id="spotlightForm"
			name="nav-search"
			action="/search/set/"
			data-action="/search/spotlight/"
			method="post"
			onSubmitCapture={(event) => event.preventDefault()}
			style={{ flex: '1', minWidth: '0' }}
		>
			<input type="hidden" name="csrf" value={CSRF} />
			<input type="hidden" name="filterType" value="add" />

			{canShowStickySearch ? (
				<input type="hidden" name="field" value="singletext" />
			) : (
				<input type="hidden" name="field" value="text" />
			)}

			<StyledInput
				ref={refInput}
				id="focus-new"
				name="value"
				value={searchTerm}
				placeholder={placeholderText}
				className="search"
				autoComplete="off"
				onChange={onValueChange}
				onClick={openSpotlightDropdown}
				onFocus={openSpotlightDropdown}
				style={{
					padding: 0,
					background: 'transparent',
					border: 'none',
				}}
				data-testid="spotlight-input-new-UI"
			/>
			{isOnCollectionPage && collectionId && (
				<input type="hidden" name="collectionId" value={collectionId} />
			)}
		</form>
	);
}

const StyledInput = styled.input`
	width: 100% !important;
	height: 100% !important;
	border-radius: 0 !important;
	font-size: ${token.fontSize100} !important;
`;
